import { Component, OnInit, ViewChild, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ISessionDetails } from '../../../interfaces/session-details';
import { IBrandInfo } from '../../../interfaces/brand/brand-info';
import { SharedService } from '../../../services/shared.service';
import { EnrollmentService } from '../../../services/enrollment/enrollment.service';
import { DataExchangeService } from '../../../services/session/data-exchange.service';
import { ComponentSectionFactoryService } from '../../../services/component-section-factory.service';
import { HeaderSectionDirective } from '../../../directives/header-section.directive';
import { FooterSectionDirective } from '../../../directives/footer-section.directive';
import { ThemeDirective } from '../../../directives/theme.directive';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-apple-recovery',
    templateUrl: './apple-recovery.component.html',
    styleUrl: './apple-recovery.component.css',
    //imports: [/*ThemeDirective, HeaderSectionDirective, FooterSectionDirective*/]
})
export class AppleRecoveryComponent implements OnInit {

  @ViewChild(HeaderSectionDirective, {static: true}) headerComponentSection!: HeaderSectionDirective;
  @ViewChild(FooterSectionDirective, {static: true}) footerComponentSection!: FooterSectionDirective;

  private readonly sharedService = inject(SharedService);
  private readonly router = inject(Router);
  private readonly dataExchangeService = inject(DataExchangeService);
  private readonly enrollmentService  = inject(EnrollmentService);
  private readonly componentSectionFactoryService = inject(ComponentSectionFactoryService);
  private readonly logger = inject(NGXLogger);

  brandStyleTheme: any = {};

  successMessage!: string;
  errorMessage!: string;
  isSuccessMessageShown: boolean = false;
  isErrorMessageShown: boolean = false;

  addToAppleWalletImage: string = '/assets/images/add-to-apple-wallet.png';
  accountId!: string;
  subtitleText!: string;
  detailsText!: string;
  enrollUrl!: string;
  isAddToAppleWalletImageShown: boolean = false;
  isTitleShown: boolean = false;
  isDetailsShown: boolean = false;

  constructor() {
  }

  ngOnInit() {
    let region: string = this.dataExchangeService.getRegion();
    let session: ISessionDetails = this.dataExchangeService.getSession();
    // let brandInfo: IBrandInfo = this.dataExchangeService.getBrandInfo();
    if (region && session) {
      let serialNumber: string = session.options.serialNumber;
      // Create form header and footer
      // this.makeHeaderAndFooter(brandInfo);
      //  Retrieve customer's reenrollment info
      this.getReenrollmentInfo(region, serialNumber, session.walPageUuid);
    }
  }

  public getReenrollmentInfo(region: string, serialNumber: string, sessionId?: string) {
    // Make a web api call
    this.enrollmentService.getAppleReenrollmentInfo(region, serialNumber, sessionId)
    .subscribe({
      next: (response) => {
        if (response) {
          this.accountId = response.extAccountId;
          this.enrollUrl = response.enrollUrl;
          if (this.accountId && this.enrollUrl) {
            this.isAddToAppleWalletImageShown = true;
          }
          let brandInfo: IBrandInfo = this.dataExchangeService.getBrandInfo();
          if (brandInfo) {
            // Chnage the subtitle
            this.subtitleText = this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_REENROLLMENT_TITLE')
            || 'Reenroll Instructions';
            // Change the details text
            let reenrollmentText = this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_REENROLLMENT_TEXT');
            if (reenrollmentText) {
              this.detailsText = reenrollmentText;
              this.isDetailsShown = true;
            }
          }
        }
      },
      error: (error) => {
        // this.logger.error('AppleRecoveryComponent - getReenrollmentInfo', error);
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });
  }

  addToAppleWallet() {
    window.location.href = this.enrollUrl;
  }

  private makeHeaderAndFooter(brandInfo: IBrandInfo) {
    this.brandStyleTheme = this.sharedService.getBrandStyleScheme(brandInfo);
    // Change the title
    let reenrollmentTitle = this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_REENROLLMENT_TITLE');
    brandInfo.sectionText = reenrollmentTitle ? reenrollmentTitle : 'WALLETRON REENROLLMENT';
    // Change the details text
    let reenrollmentText = this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_REENROLLMENT_TEXT');
    if (reenrollmentText) {
      this.detailsText = reenrollmentText;
      this.isDetailsShown = true;
    }
    // Load header and footer
    this.componentSectionFactoryService.loadHeaderSection(brandInfo, this.headerComponentSection);
    this.componentSectionFactoryService.loadFooterSection(brandInfo, this.footerComponentSection);
  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }



}
